<div class="app-airdrop-telegram" [ngClass]="httpService.theme">
    <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="font_lg bold d-flex gap-2">
            <span>
                {{ task.title }}</span>
            <span style="color: #cf0; font-weight: 100;">+{{ task.moons | number:'0.0-0' }}</span>
            <span> Moons</span>
            <span *ngIf="task.icon">
                <img width="20" [src]="task.icon" alt="" />
            </span>
        </div>
    </div>
    <div class="desc_color">
        {{ task.desc }}
    </div>
    <!-- <div class="d-flex" *ngIf="task.status === 'Pending' && !task.coming_soon">
        <cf-button [theme]="httpService.theme" [label]="task.cta" (clicked)="connectTelegram()">
        </cf-button>
    </div> -->

     <div class="d-flex" *ngIf="task.status === 'Pending'">
        <cf-button [loading]="
                            this.httpService.user.telegram &&
                            this.httpService.user.telegram
                                .verifying_group_joined
                                ? this.httpService.user.telegram
                                      .verifying_group_joined
                                : false
                        " [disabled]="
                            this.httpService.user.telegram &&
                            this.httpService.user.telegram.group_joined
                                ? this.httpService.user.telegram.group_joined
                                : false
                        " [theme]="httpService.theme" [label]="task.cta" (clicked)="connectTelegram()">
        </cf-button>
    </div>
</div>